import React from 'react';
export function UpsellSection() {
  const modules = [{
    icon: '📳',
    title: 'Introducción al análisis de vibraciones',
    desc: 'Qué es, cómo se mide y qué nos dice una vibración anormal en una máquina real'
  }, {
    icon: '🌡️',
    title: 'Termografía básica aplicada',
    desc: 'Cómo detectar puntos calientes y fallas eléctricas antes de que ocurra el paro'
  }, {
    icon: '🔬',
    title: 'Fallas complejas y diagnóstico avanzado',
    desc: 'Casos de mayor dificultad técnica: rodamientos, desalineación, resonancia y fatiga'
  }, {
    icon: '🧠',
    title: 'Casos industriales reales',
    desc: 'Situaciones documentadas de plantas argentinas con análisis técnico completo'
  }, {
    icon: '📝',
    title: 'Evaluaciones técnicas completas',
    desc: 'Instrumentos de evaluación de nivel profesional listos para aplicar en clase'
  }, {
    icon: '💼',
    title: 'Mantenimiento y mundo laboral',
    desc: 'Cómo conectar lo que el alumno aprendió con la demanda real del mercado industrial'
  }];
  return <section className="py-8 md:py-16 px-3 bg-brand-dark border-b border-white/10" data-id="element-317">
      <div className="max-w-4xl mx-auto" data-id="element-318">
        <div className="text-center mb-8" data-id="element-319">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2 uppercase text-shadow-lg" data-id="element-320">
            🔥 ¿QUÉ AGREGA EL UPSELL?
          </h2>
          <p className="text-lg md:text-2xl font-black text-brand-accent neon-glow uppercase tracking-wide" data-id="element-321">
            💣 MANTENIMIENTO PREDICTIVO Y DIAGNÓSTICO AVANZADO
          </p>
        </div>

        <div className="bg-brand-card rounded-2xl border-2 border-brand-accent p-5 md:p-8 shadow-[0_0_30px_rgba(234,179,8,0.15)] max-w-3xl mx-auto" data-id="element-322">
          <div className="space-y-3" data-id="element-323">
            {modules.map((mod, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl bg-black border border-white/10 hover:border-brand-accent/50 transition-colors" data-id="element-324">
                <span className="text-2xl md:text-3xl shrink-0 mt-1" data-id="element-325">
                  {mod.icon}
                </span>
                <div data-id="element-326">
                  <h3 className="text-base md:text-lg font-black text-white uppercase mb-1" data-id="element-327">
                    {mod.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-400 font-medium leading-relaxed" data-id="element-328">
                    {mod.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}